import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => (methodId: number) =>
  makeCall<undefined>('PUT', `/api/v2/user/me/payout-methods/set-default`, {
    data: { defaultMethodId: methodId },
  });
